<template>
    <div
        class="l-ss-c-lazy-load-anchor"
        style="height: 92px"
        ref="el"></div>
</template>

<script>
    import { onMounted, onBeforeUnmount } from '@vue/composition-api';

    export default {
        props: {
            once: {
                type: Boolean,
                default: false,
            },
        },
        setup(props, { refs, emit }) {
            let target;
            let observer;

            const installIntersectionObserver = () => {
                const options = {
                    /*
                     * Root: null,
                     * rootMargin: '200px',
                     */
                    threshold: 0.1,
                };

                const callback = (entries, observer) => {
                    if (entries[0].isIntersecting) {
                        emit('intersected');

                        if (props.once) {
                            observer.unobserve(target);
                        }
                    }
                };

                observer = new IntersectionObserver(callback, options);
                observer.observe(target);
            };

            const uninstallIntersectionObserver = () => {
                observer.unobserve(target);
                observer = null;
            };

            onMounted(() => {
                const { el } = refs;

                target = el;

                installIntersectionObserver();
            });

            onBeforeUnmount(() => {
                uninstallIntersectionObserver();
            });
        },
    };
</script>

<style scoped>

</style>
